var _circle, _circle2, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 223,
    viewBox: "0 0 223 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 111.5,
    r: 111.5,
    fill: "#D43F42",
    fillOpacity: 0.06
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.5,
    cy: 111.5,
    r: 90.5,
    fill: "#D43F42",
    fillOpacity: 0.18
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 113,
    cy: 108.5,
    rx: 47,
    ry: 46.5,
    fill: "#FFFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178 112C178 129.77 170.941 146.811 158.376 159.376C145.811 171.941 128.77 179 111 179C93.2305 179 76.1888 171.941 63.6238 159.376C51.0589 146.811 44 129.77 44 112C44 94.2305 51.0589 77.1888 63.6238 64.6238C76.1888 52.0589 93.2305 45 111 45C128.77 45 145.811 52.0589 158.376 64.6238C170.941 77.1888 178 94.2305 178 112ZM88.8398 83.9102C88.0535 83.1239 86.987 82.6822 85.875 82.6822C84.763 82.6822 83.6965 83.1239 82.9102 83.9102C82.1239 84.6965 81.6822 85.763 81.6822 86.875C81.6822 87.987 82.1239 89.0535 82.9102 89.8398L105.079 112L82.9102 134.16C82.5209 134.55 82.2121 135.012 82.0014 135.52C81.7907 136.029 81.6822 136.574 81.6822 137.125C81.6822 137.676 81.7907 138.221 82.0014 138.73C82.2121 139.238 82.5209 139.7 82.9102 140.09C83.6965 140.876 84.763 141.318 85.875 141.318C86.4256 141.318 86.9708 141.209 87.4795 140.999C87.9882 140.788 88.4504 140.479 88.8398 140.09L111 117.921L133.16 140.09C133.55 140.479 134.012 140.788 134.52 140.999C135.029 141.209 135.574 141.318 136.125 141.318C136.676 141.318 137.221 141.209 137.73 140.999C138.238 140.788 138.7 140.479 139.09 140.09C139.479 139.7 139.788 139.238 139.999 138.73C140.209 138.221 140.318 137.676 140.318 137.125C140.318 136.574 140.209 136.029 139.999 135.52C139.788 135.012 139.479 134.55 139.09 134.16L116.921 112L139.09 89.8398C139.479 89.4504 139.788 88.9882 139.999 88.4795C140.209 87.9708 140.318 87.4256 140.318 86.875C140.318 86.3244 140.209 85.7792 139.999 85.2705C139.788 84.7618 139.479 84.2996 139.09 83.9102C138.7 83.5209 138.238 83.2121 137.73 83.0014C137.221 82.7907 136.676 82.6822 136.125 82.6822C135.574 82.6822 135.029 82.7907 134.52 83.0014C134.012 83.2121 133.55 83.5209 133.16 83.9102L111 106.079L88.8398 83.9102Z",
    fill: "#D43F42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentError);
export default __webpack_public_path__ + "static/media/payment-error.5078c6d067284c760a1ae7bd7f481c1d.svg";
export { ForwardRef as ReactComponent };